import { createContext, useContext, ReactNode } from 'react'
import { useConsent } from '@/src/hooks/useConsent'
import type { ConsentFlags, ConsentState } from '@/src/lib/consent'

interface ConsentContextValue {
  consentState: ConsentState | null
  isLoading: boolean
  showBanner: boolean
  acceptAll: () => Promise<void>
  rejectAll: () => Promise<void>
  saveCustom: (flags: Partial<ConsentFlags>) => Promise<void>
  hasConsent: (category: keyof ConsentFlags) => boolean
  resetConsent: () => void
}

const ConsentContext = createContext<ConsentContextValue | null>(null)

export function ConsentProvider({ children }: { children: ReactNode }) {
  const consent = useConsent()
  return <ConsentContext.Provider value={consent}>{children}</ConsentContext.Provider>
}

export function useConsentContext(): ConsentContextValue {
  const ctx = useContext(ConsentContext)
  if (!ctx) throw new Error('useConsentContext must be used within ConsentProvider')
  return ctx
}
